import { Snackbar, SnackbarProps, styled } from "@mui/material";

import { SnackbarType } from '../../../constants/SnackbarType';

interface StyledSnackbarProps extends SnackbarProps {
  snackbarType?: string
};

export const Styles = {
  snackbar: {
    '& > div > div:first-of-type': {
      maxWidth: 338,
    },
  },
  errorSnackbar: {
    '& > div': {
      backgroundColor: '#FF5B60',
    },
    '& > div > div:first-of-type': {
      maxWidth: 338,
    },
  },
};

export const StyledSnackbar = styled(Snackbar,{
  shouldForwardProp: (prop) => prop !== 'snackbarType',
})<StyledSnackbarProps>(({ snackbarType }) => {
  const result = snackbarType === SnackbarType.Error ? Styles.errorSnackbar : Styles.snackbar;

  return result;
});